export default {
      id: "plus-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }